export default "__VITE_ASSET__D3xVMhX5__"